export const DEFAULT_TYPE_COLORS = {
  Sportivo: "#facc15",
  Manifestazione: "#7c3aed",
  "Trasporto Sanitario": "#d97706",
  Emergenza: "#dc2626",
  "Assistenza Generica": "#475569",
};
const FALLBACK = ["#0891b2", "#16a34a", "#db2777", "#4f46e5", "#9333ea", "#e11d48", "#0d9488"];

export function typeColor(type, settings) {
  const custom = settings?.service_type_colors?.[type];
  if (custom) return custom;
  if (DEFAULT_TYPE_COLORS[type]) return DEFAULT_TYPE_COLORS[type];
  let h = 0;
  for (const c of String(type || "")) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return FALLBACK[h % FALLBACK.length];
}

export function textOn(hex) {
  const n = parseInt(hex.slice(1), 16);
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6 ? "#000000" : "#ffffff";
}
